/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview A helper class that allows user to logs events to a specified
 * function.
 */

import {
  DeletedResource,
  MediaApiRequest,
  MediaApiResponse,
  ResourceSnapshot,
} from '../../types/datachannels';
import { LogLevel } from '../../types/enums';
import { LogEvent, LogSourceType } from '../../types/mediatypes';

/**
 * Helper class that helps log channel resources, updates or errors.
 */
export class ChannelLogger {
  constructor(
    private readonly logSourceType: LogSourceType,
    private readonly callback = (logEvent: LogEvent) => {
      // Default empty callback
    },
  ) { }

  log(
    level: LogLevel,
    logString: string,
    relevantObject?:
      | Error
      | DeletedResource
      | ResourceSnapshot
      | MediaApiResponse
      | MediaApiRequest,
  ) {
    this.callback({
      sourceType: this.logSourceType,
      level,
      logString,
      relevantObject,
    });
  }
}
